import { call, put, select } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ApplicationState } from 'src/core/store/index'
import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'

import * as Actions from './actions'

import { IntegrationCredential, ResponseIntegrationCredential } from './types'

export function* getIntegrationCredentials() {
  try {
    const response: ApiResponse<ResponseIntegrationCredential> = yield call(
      api.get,
      `bearer`
    )

    if (response.ok) {
      yield put(
        Actions.getIntegrationCredentialsSuccess(
          response.data.integration || []
        )
      )
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getIntegrationCredentialsFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getIntegrationCredentials', err)
    const message = i18n.t('web.integration.table.error.get-credentials')
    yield put(Actions.getIntegrationCredentialsFailure(message))
  }
}

export function* setIntegrationCredential({
  payload: { username, password }
}: ReturnType<typeof Actions.setIntegrationCredential>) {
  try {
    const {
      integrations: { list }
    } = yield select((state: ApplicationState) => state)

    const response: ApiResponse<ResponseIntegrationCredential> = yield call(
      api.post,
      `generate_bearer`,
      {
        integration: [
          {
            login: username,
            password
          }
        ]
      }
    )

    if (response.ok) {
      const updateIntegrations: IntegrationCredential[] = list.map(
        (integration: IntegrationCredential) =>
          integration.organization === response.data.integration[0].organization
            ? response.data.integration[0]
            : integration
      )

      yield put(Actions.getIntegrationCredentialsSuccess(updateIntegrations))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.setIntegrationCredentialFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga setIntegrationCredential', err)
    const message = i18n.t('web.integration.table.error.get-credentials')
    yield put(Actions.setIntegrationCredentialFailure(message))
  }
}
